import React, {Fragment, useEffect, useState} from "react";
import {connect} from 'react-redux'
// import 'bootstrap/dist/css/bootstrap.min.css';
import {Form, Row, Dropdown, FormLabel, FormGroup} from 'react-bootstrap'

import {getFilters} from '../../../actions/FilterActions'
import {FilterItem, FilterAvailableDataPoints, DataPointItem} from "../DataFilter";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {setStartDate, setEndDate} from "../../../actions";
// import 'rsuite/dist/styles/rsuite-default.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {registerLocale} from "react-datepicker";
import pl from 'date-fns/locale/pl'
import {Card, CardBody, CardHeader, Col, Collapse} from "reactstrap";
import ReactDatetime from "react-datetime";
import OPKFilter from "./OPKFilter";
import {getOPKSFilters} from '../../../actions/FilterActions'

const FilterByDate = ({Filters: {start_date, end_date, opk_filters}, PlotData: {active_plot}, Indicators: {available_indicators}, setStartDate, setEndDate,getFilters, getOPKSFilters}) => {
    useEffect(() => {
        getOPKSFilters(false)
        getFilters()


    }, [])
    useEffect(() => {getOPKSFilters(false);},[window.location.href])
    const [startDate, setStart] = useState(new Date(2021, 0, 1));
    const [endDate, setEnd] = useState(new Date(2021, 11, 31));

    const setNewStartDate = (date) => {
        if (checkIfActivePlotNeedsOpkFilter()) {
            setStart(date)
            setStartDate(date)
            setEnd(date)
            setEndDate(date)
        } else (
            setStartDateForKrs(date)
        )


    }
    const setNewEndDate = (date) => {
        if (checkIfActivePlotNeedsOpkFilter()) {
           setStart(date)
            setStartDate(date)
            setEnd(date)
            setEndDate(date)
        } else (
            setEndDateForKrs(date)
        )


    }

    registerLocale('pl', pl)


    const setStartDateForKrs = (date) => {
        let tmpDate = end_date

        if (date.year() === end_date.year()) {
            setStart(date)
            setStartDate(date)
        } else {
            setStart(date)
            setStartDate(date)
            tmpDate.set('year', date.year())
            setEnd(tmpDate)
            setEndDate(tmpDate)


        }
    }

    const setEndDateForKrs = (date) => {
        let tmpDate = end_date
        if (date.year() === start_date.year()) {
            setEnd(date)
            setEndDate(date)
        } else {
            setEnd(date)
            setEndDate(date)
            let tmpDate = start_date
            tmpDate.set('year', date.year())
            setStart(tmpDate)
            setStartDate(tmpDate)


        }
    }

    // funckja sprawdza czy aktywny wykres powinien posiadać filtr po opk
    const checkIfActivePlotNeedsOpkFilter = () => {
        if (available_indicators.length !== 0) {
            let active_indicator_exist = available_indicators.filter(x => x.nazwa === active_plot);
            if (active_indicator_exist.length !== 0) {
                if (active_indicator_exist[0].typ !== "EFP") {
                    return true
                }
            }
        }
        return false
    };
    useEffect(() => {
        if (checkIfActivePlotNeedsOpkFilter) {
            makeStartDateSameAsEnd()
        }
    }, [active_plot])

    const makeStartDateSameAsEnd = () => {
        setStart(end_date)
        setStartDate(end_date)
    }

    return (


        <>
            {
                checkIfActivePlotNeedsOpkFilter() &&
                <Col md="6" className={"okraglaczki nowaOkr "}>
                    <OPKFilter/>
                </Col>
            }
           {!checkIfActivePlotNeedsOpkFilter() && <Col className={"okraglaczki nowaOkr dateSelectWskazniki"} >
                <FormGroup>
                    <ReactDatetime
                        inputProps={{
                            className: "form-control",
                            placeholder: "Data początkowa",
                        }}
                        dateFormat={"YYYY-MM"}
                        timeFormat={false}
                        locale="pl"
                        onChange={(date) => {
                            setNewStartDate(date)
                        }}
                        value={start_date}
                    />
                    {/*<DatePicker dateFormat="dd/MM/yyyy" selected={startDate} onChange={(date) => setNewStartDate(date)} placeholder={"Data pocz�tkowa"} locale="pl"/>*/}
                </FormGroup>

            </Col> }
             <Col className={"okraglaczki nowaOkr dateSelectWskazniki"} md={checkIfActivePlotNeedsOpkFilter()? { size:6} :{size:6}}>
                <FormGroup>
                    <ReactDatetime
                        inputProps={{
                            className: "form-control",
                            placeholder: "Data końcowa:",
                        }}
                        dateFormat={"YYYY-MM"}
                        timeFormat={false}
                        locale="pl"
                        onChange={(date) => {
                            setNewEndDate(date)
                        }}
                        value={end_date}
                    />
                    {/*<DatePicker dateFormat="dd/MM/yyyy" selected={endDate} onChange={(date) => setNewEndDate(date)} placeholder={"Data ko�cowa"} locale="pl"/>*/}
                </FormGroup>

            </Col>

        </>

    )
};

const mapStateToProps = state => ({
    Filters: state.Filters,
    PlotData: state.PlotData,
    Indicators: state.Indicators

});
export default connect(mapStateToProps, {setStartDate, getFilters,setEndDate, getOPKSFilters})(FilterByDate)

